export const minZero = (value, previousValue) =>
  value >= 0 ? value : previousValue;
